import pino from 'pino';

/**
 * ログレベルごとにメッセージを定義します。
 *
 * FATAL: 想定外のシステムエラーです。全ての環境で出力します。
 * ERROR: 想定内のシステムエラーです。エラーで処理が失敗となっても運用上問題ない場合はこちらに分類します。全ての環境で出力します。
 * WARN: 業務エラーです。全ての環境で出力します。
 * INFO: 通常のログです。全ての環境で出力します。
 * DEBUG: デバッグ情報です。ローカルとdev環境で出力します。
 * TRACE: デバッグ情報です。ローカルでのみ出力します。
 */
const UntypedLogMsg = {
  // グローバルハンドラ
  UncaughtError: { level: <pino.Level>'fatal', code: '0101', msg: '予期しないエラー' },
  UncaughtPromiseError: { level: <pino.Level>'fatal', code: '0102', msg: 'Promise内の予期しないエラー' },
  UncaughtVueError: { level: <pino.Level>'fatal', code: '0103', msg: 'Vueコンポーネント内の予期しないエラー' },
  VueWarn: { level: <pino.Level>'warn', code: '0104', msg: 'Vueの実行時警告' },
  UncaughtVueRouterError: { level: <pino.Level>'fatal', code: '0105', msg: 'VueRouter内の予期しないエラー' },

  // 画面遷移
  RouteBeforeEach: { level: <pino.Level>'info', code: '0201', msg: '画面遷移' },
  RouteAfterEach: { level: <pino.Level>'debug', code: '0202', msg: '画面遷移' },
  TransitionForbiddenPage: { level: <pino.Level>'warn', code: '0203', msg: '403 Forbiddenページへの遷移' },
  TransitionNotFoundPage: { level: <pino.Level>'warn', code: '0204', msg: '404 NotFoundページへの遷移' },
  TransitionInternalServerErrorPage: { level: <pino.Level>'warn', code: '0205', msg: '500 InternalServerErrorページへの遷移' },
  TransitionServiceUnavailablePage: { level: <pino.Level>'warn', code: '0206', msg: '503 ServiceUnavailableページへの遷移' },
  RoutePermissionError: { level: <pino.Level>'error', code: '0207', msg: '権限のないURLへのアクセス' },
  WindowOpen: { level: <pino.Level>'info', code: '0208', msg: '別タブを開くURL遷移' },

  // APIリクエスト
  ApiRequestInfo: { level: <pino.Level>'debug', code: '0301', msg: 'APIリクエスト' },
  ApiRequestError: { level: <pino.Level>'error', code: '0302', msg: 'APIリクエストエラー' },
  ApiResponseInfo: { level: <pino.Level>'debug', code: '0303', msg: 'APIレスポンス' },
  ApiResponseError: { level: <pino.Level>'error', code: '0304', msg: 'APIレスポンスエラー' },
  FileUploadError: { level: <pino.Level>'error', code: '0305', msg: 'ファイルアップロードエラー' },

  // バリデーション
  UncaughtValidationCheckError: { level: <pino.Level>'error', code: '0401', msg: 'バリデーションチェック内の予期しないエラー' },
  ValidationCheckFailure: { level: <pino.Level>'warn', code: '0402', msg: 'バリデーションチェックエラー' },
  ValidatitonCheckSuccess: { level: <pino.Level>'debug', code: '0403', msg: 'バリデーションチェック通過' },

  // 通知処理
  NotificationBanner: { level: <pino.Level>'debug', code: '0501', msg: 'バナー通知' },

  // 外部ライブラリ
  GoogleMapError: { level: <pino.Level>'error', code: '0601', msg: 'GoogleMapエラー' },
};

export type LogMsgKey = keyof typeof UntypedLogMsg;
type LogMsgValue = { level: pino.Level; code: string; msg: string };
export const LogMsg: Record<LogMsgKey, LogMsgValue> = UntypedLogMsg;
